import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import combineReducers from './reducers/index'
import { composeWithDevTools } from 'redux-devtools-extension';

const persistConfig = {
  key: 'v001',
  storage,
}

const persistedReducer = persistReducer(persistConfig, combineReducers)

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)

export default store;
